import { type ChangeEvent } from "react";
import { Input } from "@/components/ui/input";
import XLSX from 'xlsx';

export const XlsxFileInput = ({ onFileLoad }: { onFileLoad: (args: unknown[]) => void }) => {
    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const files = (e.target as HTMLInputElement).files;
        if (files) {
            const file = files[0];
            const reader = new FileReader();
            reader.onload = (event) => {
                if (!event.target || !event.target.result) return;
                const data = new Uint8Array((event.target.result! as ArrayBuffer));
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);
                onFileLoad(jsonData);
            };
            reader.readAsArrayBuffer(file);
        }
    };
    return (
        <div>
            <Input type="file" onChange={handleFileChange} />
        </div>
    );
};
